module.exports = __webpack_public_path__ + "img/medalGold.73d40394.png";